import { render, staticRenderFns } from "./ServerTable.vue?vue&type=template&id=b6cf68d4"
import script from "./ServerTable.vue?vue&type=script&lang=js"
export * from "./ServerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports